import { IProjectCostCodeCostTypeItemsRevision } from '../../interfaces/iproject-cost-code-cost-type-items-revision';
import { CostCodeCostType } from '../cost-code-cost-type';
import { Project } from '../project';
import { ProjectEstimate } from '../project-estimate';
import { ScheduleActivity } from '../schedule-activity';
import { UnitOfMeasure } from '../unit-of-measure';

export class ProjectCostCodeCostTypeItemsRevisionBase {
  ProjectCostCodeCostTypeItemsRevisionId: number;
  ProjectId: number;
  CostCodeCostTypeId: number | null;
  EstimateDate: Date | null;
  ExtendedValue: number | null;
  Quantity: number | null;
  EstimateVersion: number | null;
  LastUpdatedDate: Date | null;
  LastUpdatedUser: string | null;
  Rate: number | null;
  UnitOfMeasureId: number | null;
  IsManualAdd: boolean | null;
  Phase: string | null;
  Step: string | null;
  NeedByDate: Date | null;
  ScheduleActivityId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  ProjectEstimateId: number | null;

  CostCodeCostType?: CostCodeCostType;
  ProjectEstimate?: ProjectEstimate;
  Project?: Project;
  ScheduleActivity?: ScheduleActivity;
  UnitOfMeasure?: UnitOfMeasure;

  constructor(item?: IProjectCostCodeCostTypeItemsRevision) {
    if (item) {

      this.ProjectCostCodeCostTypeItemsRevisionId = item.ProjectCostCodeCostTypeItemsRevisionId;
      this.ProjectId = item.ProjectId;
      this.CostCodeCostTypeId = item.CostCodeCostTypeId;
      this.EstimateDate = item.EstimateDate ? new Date(item.EstimateDate) : null;
      this.ExtendedValue = item.ExtendedValue;
      this.Quantity = item.Quantity;
      this.EstimateVersion = item.EstimateVersion;
      this.LastUpdatedDate = item.LastUpdatedDate ? new Date(item.LastUpdatedDate) : null;
      this.LastUpdatedUser = item.LastUpdatedUser;
      this.Rate = item.Rate;
      this.UnitOfMeasureId = item.UnitOfMeasureId;
      this.IsManualAdd = item.IsManualAdd;
      this.Phase = item.Phase;
      this.Step = item.Step;
      this.NeedByDate = item.NeedByDate ? new Date(item.NeedByDate) : null;
      this.ScheduleActivityId = item.ScheduleActivityId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.ProjectEstimateId = item.ProjectEstimateId;

      this.CostCodeCostType = new CostCodeCostType(item.CostCodeCostType);
      this.ProjectEstimate = new ProjectEstimate(item.ProjectEstimate);
      this.Project = new Project(item.Project);
      this.ScheduleActivity = new ScheduleActivity(item.ScheduleActivity);
      this.UnitOfMeasure = new UnitOfMeasure(item.UnitOfMeasure);
    }
  }
}